{
  "familyId": "SWW-LEEN-ENG-STAM",
  "questions": [
    {
      "id": "SWW-LEEN-ENG-STAM-001",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "multiple_choice",
      "question": "Wat is de stam van het werkwoord 'racen'?",
      "context": null,
      "options": ["race", "rac", "raac", "races"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "Bij Engelse leenwoorden bepaal je de stam op dezelfde manier: werkwoord min -en. Let op de klank, niet de spelling.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_stem",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: Engelse leenwoorden — stam bepalen. Stap 1: Neem het werkwoord: racen. Stap 2: Haal -en af: racen − en = race. Stap 3: De Engelse spelling blijft behouden: 'race' (met -ce). De stam is 'race'. Checkstrategie: bij Engelse leenwoorden altijd de Engelse spelling behouden. Controleer: klinkt de stam nog als het Engelse woord? race ✓",
        "distractorExplanations": {
          "0": "Correct! Engelse leenwoorden: werkwoord − en = race. De Engelse spelling blijft behouden.",
          "1": "Veelgemaakte fout: de Engelse spelling aanpassen aan Nederlandse regels. 'Rac' mist de -e. De Engelse spelling 'race' (met -ce) blijft behouden: racen − en = race. Misconceptie: denken dat je de stam 'vernederlandst'.",
          "2": "Veelgemaakte fout: de klinker verdubbelen. 'Raac' heeft een dubbele a die niet in het Engelse woord staat. De Engelse spelling is 'race' (met één a). Misconceptie: Nederlandse spellingregels toepassen op Engelse leenwoorden.",
          "3": "Veelgemaakte fout: een extra letter toevoegen. 'Races' heeft een -s die niet bij de stam hoort. De stam is gewoon: race (werkwoord − en). Misconceptie: de Engelse meervoudsvorm verwarren met de stam."
        }
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-002",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "multiple_choice",
      "question": "Vul in: Ik ... de hele dag. (chillen)",
      "context": null,
      "options": ["chill", "chil", "chille", "chillen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "Bij 'ik' gebruik je alleen de stam. De stam van 'chillen' is 'chill' (met dubbel l, Engelse spelling).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_first_person",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Regel: Engelse leenwoorden — stam bij ik-vorm. Stap 1: Neem het werkwoord: chillen. Stap 2: Haal -en af: chillen − en = chill. Stap 3: De Engelse spelling blijft behouden: 'chill' (met dubbel l). Stap 4: Bij 'ik' gebruik je alleen de stam: ik chill. Checkstrategie: klinkt de stam nog als het Engelse woord? chill ✓ Behoud altijd de Engelse spelling.",
        "distractorExplanations": {
          "0": "Correct! Engelse leenwoorden: chillen − en = chill (dubbel l behouden). Bij 'ik' alleen de stam.",
          "1": "Veelgemaakte fout: de dubbele medeklinker weglaten. 'Chil' (enkel l) is de Nederlandse regel, maar bij Engelse leenwoorden behoud je de Engelse spelling: chill (dubbel l). Misconceptie: Nederlandse spellingregels toepassen op Engelse leenwoorden.",
          "2": "Veelgemaakte fout: een extra -e toevoegen aan de stam. 'Chille' is geen correcte vorm. Bij 'ik' gebruik je alleen de stam: chill (geen -e). Misconceptie: denken dat de ik-vorm een uitgang krijgt.",
          "3": "Veelgemaakte fout: het hele werkwoord gebruiken als ik-vorm. 'Chillen' is het hele werkwoord. Bij 'ik' gebruik je alleen de stam: chill. Misconceptie: het hele werkwoord verwarren met de persoonsvorm."
        }
      }
    }
  ]
}